import { CommonGet, CommonPost } from "../../../utils/CommonFetch";


export default {
    
    getAllGroupsForDropdown,
    getOperationEntityByGroup,
    getQRTagByGroupIDOperationEntityID,
    updateStatus,
    getAllRoutesByFactoryID
};

async function getAllGroupsForDropdown() {
    var groupArray = [];

    const response = await CommonGet('/api/Group/GetAllGroups', null)
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            groupArray[item[1]["groupID"]] = item[1]["groupName"]
        }
    }
    return groupArray;
}

async function getOperationEntityByGroup(groupID){
    var operationEntityArray = [];
    const response = await CommonGet('/api/OperationEntity/GetOperationEntityByGroupIDEntityID','groupID=' + groupID);
    for (let item of Object.entries(response.data)) {
        operationEntityArray[item[1]["operationEntityID"]] = item[1]["operationEntityName"];
    }
     return operationEntityArray;
}

async function getAllRoutesByFactoryID(factoryID) {
    var routeArray = [];
    const response = await CommonGet('/api/CollectionPoint/GetAllRoutesByFactoryID', 'factoryID=' + factoryID);
    for (let item of Object.entries(response.data)) {
        if (item[1]["isActive"] === true) {
            routeArray[item[1]["collectionPointID"]] = item[1]["collectionPointName"]
        }
    }
    return routeArray;  
}

async function getQRTagByGroupIDOperationEntityID(groupID, operationEntityID, routeID) {
    console.log("routeID",routeID)
    const response = await CommonGet('/api/QRtag/GetQRTagForQRCode', 'groupID=' + groupID + '&operationEntityID=' + operationEntityID + '&collectionPointID=' + routeID );
    return response.data;
    
}

async function updateStatus(data) {
    // const response = await CommonPost('/api/QRtag/UpdateCollectionTagIsPrint', null, data);
    // return response;
}

